export const grass = {
  1: { value: { base: '{colors.grass.light.1}', _dark: '{colors.grass.dark.1}' } },
  2: { value: { base: '{colors.grass.light.2}', _dark: '{colors.grass.dark.2}' } },
  3: { value: { base: '{colors.grass.light.3}', _dark: '{colors.grass.dark.3}' } },
  4: { value: { base: '{colors.grass.light.4}', _dark: '{colors.grass.dark.4}' } },
  5: { value: { base: '{colors.grass.light.5}', _dark: '{colors.grass.dark.5}' } },
  6: { value: { base: '{colors.grass.light.6}', _dark: '{colors.grass.dark.6}' } },
  7: { value: { base: '{colors.grass.light.7}', _dark: '{colors.grass.dark.7}' } },
  8: { value: { base: '{colors.grass.light.8}', _dark: '{colors.grass.dark.8}' } },
  9: { value: { base: '{colors.grass.light.9}', _dark: '{colors.grass.dark.9}' } },
  10: { value: { base: '{colors.grass.light.10}', _dark: '{colors.grass.dark.10}' } },
  11: { value: { base: '{colors.grass.light.11}', _dark: '{colors.grass.dark.11}' } },
  12: { value: { base: '{colors.grass.light.12}', _dark: '{colors.grass.dark.12}' } },
  a1: { value: { base: '{colors.grass.light.a1}', _dark: '{colors.grass.dark.a1}' } },
  a2: { value: { base: '{colors.grass.light.a2}', _dark: '{colors.grass.dark.a2}' } },
  a3: { value: { base: '{colors.grass.light.a3}', _dark: '{colors.grass.dark.a3}' } },
  a4: { value: { base: '{colors.grass.light.a4}', _dark: '{colors.grass.dark.a4}' } },
  a5: { value: { base: '{colors.grass.light.a5}', _dark: '{colors.grass.dark.a5}' } },
  a6: { value: { base: '{colors.grass.light.a6}', _dark: '{colors.grass.dark.a6}' } },
  a7: { value: { base: '{colors.grass.light.a7}', _dark: '{colors.grass.dark.a7}' } },
  a8: { value: { base: '{colors.grass.light.a8}', _dark: '{colors.grass.dark.a8}' } },
  a9: { value: { base: '{colors.grass.light.a9}', _dark: '{colors.grass.dark.a9}' } },
  a10: { value: { base: '{colors.grass.light.a10}', _dark: '{colors.grass.dark.a10}' } },
  a11: { value: { base: '{colors.grass.light.a11}', _dark: '{colors.grass.dark.a11}' } },
  a12: { value: { base: '{colors.grass.light.a12}', _dark: '{colors.grass.dark.a12}' } },
}
